import React, { useState } from 'react';
import { Card, Text, IconButton } from '@perch-labs/shrike';
import { copyFor } from 'config';
import { Container } from 'styles';
import { DashboardRow } from '../dashboard-row';
import { StyledList } from '../dashboard.style';
import { CardHeader } from './closed-plans.style';
import { PlansWrapper } from '../plans-wrapper';

const getCopy = copyFor('dashboard.standardDashboard.closedPlans');

interface Props {
  enableAccordionFunctionality: boolean;
  inactivePlansCount: number;
}

export const ClosedPlans = ({
  enableAccordionFunctionality,
  inactivePlansCount,
}: Props) => {
  const [accordionIsOpen, setAccordionIsOpen] = useState(
    !enableAccordionFunctionality
  );

  return (
    <Card mobileVariant="flat" margin={{ bottom: '24px' }}>
      <CardHeader accordionIsOpen={accordionIsOpen}>
        <Container
          flex
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Text tag="h2" textStyle="heading700">
            {getCopy('title')}
          </Text>
          {enableAccordionFunctionality && (
            <IconButton
              data-testid="toggle-closed-plans-accordion"
              aria-label={getCopy('ariaButtonLabel', {
                action: accordionIsOpen ? 'Hide' : 'Reveal',
              })}
              onClick={() => setAccordionIsOpen(!accordionIsOpen)}
              icon="ChevronDown"
            />
          )}
        </Container>
      </CardHeader>
      {accordionIsOpen && (
        <PlansWrapper status="inactive" count={inactivePlansCount}>
          {({ plans, showPagination }) => (
            <Container small={{ padding: '0 24px' }}>
              <StyledList showPagination={showPagination}>
                {plans.map(plan => (
                  <DashboardRow key={`dashboard-list-${plan.id}`} plan={plan} />
                ))}
              </StyledList>
            </Container>
          )}
        </PlansWrapper>
      )}
    </Card>
  );
};
